module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/components/WGCWXRewardsTankConfirmation/images/error_light.5bb90c53.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/WGCWXRewardsTankConfirmation/images/error_light.png
// module id = 1054
// module chunks = 16